module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_kimono@2x-7078c0591352272d7e3b24479b116da5.webp";